import { useConfig } from '@@/common/services/useConfig';

import NotFoundView from './NotFoundView';

export default function NotFoundViewForTenant() {
  const {
    config: { notFoundPageConfig },
  } = useConfig();

  return <NotFoundView notFoundPageConfig={notFoundPageConfig} />;
}
